import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { AuthProvider } from "./Context/AuthContext";
//import ProtectedRoute from "./Context/ProtectedRoute";

// Lazy Load Pages
const Home = React.lazy(() => import("./Pages/Home"));
const About = React.lazy(() => import("./Pages/About"));
const Contact = React.lazy(() => import("./Pages/Contact"));
const PrivacyPolicy = React.lazy(() => import("./Pages/PrivacyPolicy"));
const TermsAndConditions = React.lazy(() => import("./Pages/TermsAndConditions"));
const Services = React.lazy(() => import("./Pages/Services"));
const Login = React.lazy(() => import("./Pages/Login"));
const NotFound = React.lazy(() => import("./Pages/NotFound"));

// Admin Pages
/*const AdminDashboard = React.lazy(() => import("./Pages/Admin/Dashboard"));
const UserManagement = React.lazy(() => import("./Pages/Admin/UserManagement"));
const FileManagement = React.lazy(() => import("./Pages/Admin/FileManagement"));
const Reports = React.lazy(() => import("./Pages/Admin/Reports"));
const AuditLogs = React.lazy(() => import("./Pages/Admin/AuditLogs"));
const AdminSettings = React.lazy(() => import("./Pages/Admin/Settings"));

// Customer Pages
const CustomerDashboard = React.lazy(() => import("./Pages/Customer/CustomerDashboard"));
const Files = React.lazy(() => import("./Pages/Customer/Files"));
const Notifications = React.lazy(() => import("./Pages/Customer/Notifications"));
const CustomerSettings = React.lazy(() => import("./Pages/Customer/Settings")); */

// Service Pages (Add the import for Testing and Commissioning here)
const TestingAndCommissioning = React.lazy(() => import("./Pages/Service/TestingAndCommissioning"));
const ProtectionRelayTesting = React.lazy(() => import("./Pages/Service/ProtectionRelayTesting"));
const AnnualMaintenance = React.lazy(() => import("./Pages/Service/AnnualMaintenance"));
const BreakerTesting = React.lazy(() => import("./Pages/Service/BreakerTesting"));
const CableManagent = React.lazy(() => import("./Pages/Service/CableManagement"));
const CCTV = React.lazy(() => import("./Pages/Service/cctv"));
const CurrentPotential = React.lazy(() => import("./Pages/Service/CurrentPotential"));
const ElectricalServices = React.lazy(() => import("./Pages/Service/ElectricalServices"));
const Generatorturbine = React.lazy(() => import("./Pages/Service/Generatorturbine"));
const HdvcEquimnets = React.lazy(() => import("./Pages/Service/HvdcEquipments"));
const PowerQuality = React.lazy(() => import("./Pages/Service/PowerQuality"));
const Retrofitting = React.lazy(() => import("./Pages/Service/Retrofitting"));
const TransformerTesting = React.lazy(() => import("./Pages/Service/TransformerTesting"));

// ✅ Loader (Centered Circular Progress)
const Loader = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    <CircularProgress />
  </Box>
);

const App = () => (
  <AuthProvider>
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", width: "100vw", overflowX: "hidden" }}>
      
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* ✅ Public Pages (With Header & Footer) */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1 }}>
                  <Home />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/home"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1 }}>
                  <Home />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1, py: 3 }}>
                  <About />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1, py: 3 }}>
                  <Contact />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/services"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1, py: 3 }}>
                  <Services />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1, py: 3 }}>
                  <PrivacyPolicy />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/terms-and-conditions"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1, py: 3 }}>
                  <TermsAndConditions />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/login"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1, py: 3 }}>
                  <Login />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/testing-and-commissioning"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1, py: 3 }}>
                  <TestingAndCommissioning />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/protection-relay-testing"
            element={
              <>
                <Header />
                <Box sx={{ flexGrow: 1, py: 3 }}>
                  <ProtectionRelayTesting />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
  path="/annual-maintenance-services"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <AnnualMaintenance />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/breaker-testing"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <BreakerTesting />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/cable-management-installation"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <CableManagent />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/cctv-installation"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <CCTV />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/current-potential-transformer-testing"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <CurrentPotential />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/electrical-erection-services"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <ElectricalServices />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/generator-turbine-panel-testing"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <Generatorturbine />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/hvdc-equipment-testing"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <HdvcEquimnets />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/power-quality-testing"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <PowerQuality />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/retrofitting-condition-assessment"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <Retrofitting />
      </Box>
      <Footer />
    </>
  }
/>
<Route
  path="/transformer-testing-diagnostics"
  element={
    <>
      <Header />
      <Box sx={{ flexGrow: 1, py: 3 }}>
        <TransformerTesting />
      </Box>
      <Footer />
    </>
  }
/>

          {/* ✅ Admin Panel (Without Header & Footer) 
          <Route path="/admin/dashboard" element={<ProtectedRoute element={<AdminDashboard />} allowedRoles={["admin","super_admin"]} />} />
          <Route path="/admin/users" element={<ProtectedRoute element={<UserManagement />} allowedRoles={["admin","super_admin"]} />} />
          <Route path="/admin/files" element={<ProtectedRoute element={<FileManagement />} allowedRoles={["admin","super_admin"]} />} />
          <Route path="/admin/reports" element={<ProtectedRoute element={<Reports />} allowedRoles={["admin","super_admin"]} />} />
          <Route path="/admin/audit-logs" element={<ProtectedRoute element={<AuditLogs />} allowedRoles={["admin","super_admin"]} />} />
          <Route path="/admin/settings" element={<ProtectedRoute element={<AdminSettings />} allowedRoles={["admin","super_admin"]} />} />*/}

          {/* ✅ Customer Panel (Without Header & Footer) 
          <Route path="/customer/dashboard" element={<ProtectedRoute element={<CustomerDashboard />} allowedRoles={["customer"]} />} />
          <Route path="/customer/files" element={<ProtectedRoute element={<Files />} allowedRoles={["customer"]} />} />
          <Route path="/customer/notifications" element={<ProtectedRoute element={<Notifications />} allowedRoles={["customer"]} />} />
          <Route path="/customer/settings" element={<ProtectedRoute element={<CustomerSettings />} allowedRoles={["customer"]} />} />*/}

          {/* ✅ 404 Page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      
    </Box>
  </AuthProvider>
);

export default App;
